var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClear48Line = function SvgIconClear48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3A16.7 16.7 0 1 0 40.7 24 16.72 16.72 0 0 0 24 7.3Zm0 30A13.3 13.3 0 1 1 37.3 24 13.32 13.32 0 0 1 24 37.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 16.422 24 21.602l-5.17-5.18-2.41 2.41 5.18 5.17-5.18 5.17 2.41 2.41 5.17-5.18 5.17 5.18 2.41-2.41-5.17-5.17 5.17-5.17-2.41-2.41Z",
    fill: "current"
  })));
};
export default SvgIconClear48Line;